<template>
  <div class="parallax-banner">
    <picture>
      <source 
        :srcset="`${imageUrl}?w=1200 1200w, ${imageUrl}?w=800 800w, ${imageUrl}?w=480 480w`" 
        type="image/jpeg"
      >
      <img 
        :src="imageUrl"
        :alt="title"
        class="banner-image"
        @load="handleImageLoad"
        :class="{ 'is-loaded': isLoaded }"
      >
    </picture>
    <div class="banner-content">
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerImovel",
  props: {
    title: {
      type: String,
      default: "Sobrado XPTO",
    },
    description: {
      type: String,
      default: "3 dormitórios, 1 suíte, 3 vagas na garagem",
    },
    imageUrl: {
      type: String,
      default: '/casaRegina/fachada-6.jpeg'
    }
  },
  data() {
    return {
      isLoaded: false
    }
  },
  methods: {
    handleImageLoad() {
      this.isLoaded = true
    }
  }
};
</script>

<style scoped>
.parallax-banner {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  transform: translateZ(0); /* Hardware acceleration */
  will-change: transform; /* Optimize for animations */
}

.banner-image.is-loaded {
  opacity: 1;
}

/* Camada escura (overlay) com animação */
.parallax-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Camada escura com 50% de opacidade */
  z-index: 1;
  opacity: 0;
  animation: fadeIn 1s ease forwards; /* Animação de fade in */
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  z-index: 2; /* Coloca o texto acima da camada escura */
  padding: 0 15px;
  opacity: 0;
  animation: fadeInUp 1s ease forwards 0.5s; /* Animação do texto */
}

.banner-content h1 {
  font-size: 36px;
  font-weight: bold;
}

.banner-content p {
  font-size: 18px;
}

/* Animação do fade in */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Animação do fade in com deslocamento de cima para baixo */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate(-50%, -40%); /* Começa mais acima */
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%); /* Fica centralizado no final */
  }
}

/* Responsividade para mobile */
@media (max-width: 600px) {
  .banner-content h1 {
    font-size: 24px; /* Diminui o tamanho do título no mobile */
  }

  .banner-content p {
    font-size: 14px; /* Diminui o tamanho da descrição no mobile */
  }

  .parallax-banner {
    height: 60vh; /* Diminui a altura do banner no mobile */
    background-position: center center; /* Mantém a centralização no mobile */
  }
}
</style>